import React from 'react';
import './style.less';

export interface ChargeBreakdownAmounts {
    currency?: string;
    subtotalCents: number;
    taxCents: number;
    totalCents: number;
    taxPercent?: number;
}

export const formatChargeCents = (cents: number, currency = 'USD'): string => (
    (Math.round(Number(cents) || 0) / 100).toLocaleString(undefined, { style: 'currency', currency: currency.toUpperCase() })
);

interface Props {
    breakdown: ChargeBreakdownAmounts;
    totalLabel?: string;
    note?: string;
}

// Subtotal / Tax / Total, from the server's own charge breakdown, so residents see the
// tax-inclusive amount they are asked to consent to.
const ChargeBreakdown: React.FC<Props> = ({ breakdown, totalLabel = 'Total', note }) => {
    const currency = breakdown.currency || 'USD';
    const taxPercent = Number(breakdown.taxPercent);
    const taxLabel = Number.isFinite(taxPercent) && taxPercent > 0 ? `Tax (${taxPercent}%)` : 'Tax';
    return (
        <div className="neighbors-charge-breakdown">
            <div className="ncb-row">
                <span>Subtotal</span>
                <span>{formatChargeCents(breakdown.subtotalCents, currency)}</span>
            </div>
            {breakdown.taxCents > 0 && (
                <div className="ncb-row">
                    <span>{taxLabel}</span>
                    <span>{formatChargeCents(breakdown.taxCents, currency)}</span>
                </div>
            )}
            <div className="ncb-row ncb-total">
                <span>{totalLabel}</span>
                <span>{formatChargeCents(breakdown.totalCents, currency)}</span>
            </div>
            {note && <div className="ncb-note">{note}</div>}
        </div>
    );
};

export default ChargeBreakdown;
